import { render, staticRenderFns } from "./LegalDocumentContent_5BAZaE.vue?vue&type=template&id=81da2b12&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_5BAZaE.vue?vue&type=style&index=0&id=81da2b12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81da2b12",
  null
  
)

export default component.exports